import React, { Component } from 'react'
import { object, string } from 'prop-types'
import OFT from './OFT'

class OrderBar extends Component {
  render() {
    const {
      order_number,
      on_street,
      from_street,
      to_street,
      object_key,
      sos,
      signs,
    } = this.props.order.properties
    return (
      <div className="order-bar">
        <OFT
          orderNumber={order_number}
          onStreet={on_street}
          fromStreet={from_street}
          toStreet={to_street}
          objectKey={object_key}
          sos={sos}
          signs={signs.length}
          theme={this.props.theme}
        />
      </div>
    )
  }
}

OrderBar.propTypes = {
  order: object.isRequired,
  theme: string.isRequired,
}

export default OrderBar



// WEBPACK FOOTER //
// ./src/components/List/OrderBar/index.jsx